export function GovernIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Inner control bars */}
      <path
        fill="#FFFFFF"
        d="M13.167 7.5a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.334 0M15.167 10.5a.5.5 0 0 0-1 0v4.667a.5.5 0 0 0 1 0zM12 10a.5.5 0 0 1 .5.5v3.333a.5.5 0 1 1-1 0V10.5a.5.5 0 0 1 .5-.5M9.833 10.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0z"
      />
      {/* Outer shield */}
      <path
        fill="#06B6D4"
        fillRule="evenodd"
        d="M4.333 3.5a.5.5 0 0 1 .5-.5h14.334a.5.5 0 0 1 .5.5v10.888c0 1.07-.542 2.069-1.439 2.653l-5.955 3.878a.5.5 0 0 1-.546 0l-5.955-3.878a3.17 3.17 0 0 1-1.439-2.653zm1 .5v10.388c0 .732.37 1.415.985 1.815l5.682 3.7 5.682-3.7c.614-.4.985-1.083.985-1.815V4z"
        clipRule="evenodd"
      />
    </svg>
  );
}
